import type { CookieDeclaration, PrivacyServiceManifest } from "./types.js";

export interface CleanupReport {
  cookiesAttempted: string[];
  storageKeysRemoved: string[];
}

function normalizeCookie(cookie: string | CookieDeclaration): CookieDeclaration {
  return typeof cookie === "string" ? { name: cookie, path: "/" } : cookie;
}

export function cleanupDeclaredStorage(
  service: PrivacyServiceManifest,
  documentLike: Pick<Document, "cookie"> | null =
    typeof globalThis.document === "undefined" ? null : globalThis.document,
  storage: Pick<Storage, "removeItem"> | null =
    typeof globalThis.localStorage === "undefined" ? null : globalThis.localStorage,
): CleanupReport {
  const report: CleanupReport = { cookiesAttempted: [], storageKeysRemoved: [] };

  for (const rawCookie of service.cookies) {
    const cookie = normalizeCookie(rawCookie);
    report.cookiesAttempted.push(cookie.name);
    if (documentLike) {
      const path = cookie.path ?? "/";
      const domain = cookie.domain ? `; Domain=${cookie.domain}` : "";
      documentLike.cookie = `${cookie.name}=; Max-Age=0; Path=${path}${domain}; SameSite=Lax`;
    }
  }
  for (const key of service.storageKeys) {
    if (storage) {
      try {
        storage.removeItem(key);
      } catch {
        // The controller remains fail-closed even if the browser blocks cleanup.
      }
    }
    report.storageKeysRemoved.push(key);
  }
  return report;
}
